import {remCalc} from '../../_utils'

export default {
    baseStyle: ({addressLength}: {addressLength: number}) => ({
        stack: {
            position: 'absolute',
            top: remCalc(-50),
            right: remCalc(0),
            gap: '0',
        },
        childrenFlex: {
            textStyle: 'body-medium',
            flexDirection: 'column',
        },
        guestActionCardContainer: {
            p: remCalc(16),
            flexDirection: 'column',
            gap: remCalc(8),
            position: 'relative',
            cursor: 'pointer',
            border: 'small',
            borderStyle: 'solid',
            borderColor: 'border.light',
            minWidth: {lg: addressLength > 1 ? 'unset' : remCalc(451)},
            w: '100%',
        },
        pickupAddressCardContainer: {
            p: remCalc(16),
            flexDirection: 'row',
            gap: remCalc(8),
            position: 'relative',
            cursor: 'pointer',
            border: 'small',
            borderStyle: 'solid',
            borderColor: 'border.light',
            minWidth: {lg: addressLength > 1 ? 'unset' : remCalc(451)},
        },
        cardContainer: {
            p: `${remCalc(24)} ${remCalc(20)} ${remCalc(20)} ${remCalc(20)}`,
            flexDirection: 'column',
            gap: remCalc(20),
            position: 'relative',
            cursor: 'pointer',
            border: 'small',
            borderStyle: 'solid',
            borderColor: 'border.light',
            minWidth: {lg: addressLength > 1 ? 'unset' : remCalc(451)},
            outline: 'none',
        },
        cardAccesibility: {
            _focus: {
                outline: 'none !important',
                boxShadow: 'none !important',
            },
            _focusVisible: {
                outline: '2px solid !important',
                outlineColor: 'blue.500 !important',
                outlineOffset: '2px !important',
                boxShadow: 'none !important',
            },
        },
        radioCardFlexChild: {
            alignItems: 'center',
            gap: remCalc(9),
        },
        radioCardText: {
            textStyle: 'body-small',
            fontWeight: 'bold',
        },
        customRadioInputContainer: {
            h: remCalc(24),
            w: remCalc(24),
            border: 'small',
            borderStyle: 'solid',
            borderRadius: '50%',
        },
        customRadioInputContainerBull: {
            h: remCalc(12),
            w: remCalc(12),
            m: remCalc(5),
            borderStyle: 'solid',
            borderRadius: '50%',
            backgroundColor: 'background.dark',
        },
        addressName: {
            textStyle: 'body-medium',
            fontWeight: 'medium',
        },
        privacyText: {
            color: 'text.secondary',
            textStyle: 'body-small',
        },
    }),
    variants: {
        'address-card': {
            closeButton: {
                position: 'absolute',
                top: remCalc(24),
                right: remCalc(20),
                display: 'flex',
            },
            actionCardBox: {
                maxW: {base: '100%', lg: remCalc(451)},
                padding: remCalc(20),
                paddingTop: remCalc(24),
                border: 'small',
                borderStyle: 'solid',
                borderColor: 'border.light',
            },
            actionCardStack: {
                gap: remCalc(40),
                height: '100%',
                justifyContent: 'space-between',
            },
            checkboxDefault: {
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                gap: remCalc(8),
                label: {
                    fontSize: 'sm',
                    fontWeight: 'bold',
                },
            },
        },
        //RIVEDERE BENE GLI STILI PER VARIANT BOXED, PERCHE NON TUTTI SERVONO, CON QUESTI STILI ANDIAMO A MODIFICARE GLI STILI INTERNI AD ACTION CARD
        boxed: {
            stack: {
                position: 'absolute',
                top: remCalc(8),
                right: remCalc(15),
                gap: '0',
            },
            editPosition: {
                position: 'relative',
                top: 'auto',
                right: 'auto',
            },
            childrenFlex: {
                textStyle: 'body-medium',
                flexDirection: 'row',
                gap: remCalc(8),
                alignItems: 'flex-start',
                w: '100%',
            },
            actionCardStack: {
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'flex-start',
                width: '100%',
            },
        },
        checkout: {
            actionCardStack: {
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'flex-start',
                width: '100%',
            },
            actionCardBox: {
                width: '100%',
            },

            childrenFlex: {
                flex: 1,
                marginRight: remCalc(16),
                width: '100%',
            },

            editPosition: {
                position: 'relative',
                top: 'auto',
                right: 'auto',
            },
            cardContainer: {
                padding: `${remCalc(16)} ${remCalc(16)} ${remCalc(16)} ${remCalc(16)}`,
                flexDirection: 'row',
                alignItems: 'flex-start',
                gap: remCalc(8),
            },
            radioCardText: {
                display: 'none',
            },
        },
    },
    parts: [
        'actionCardBox',
        'actionCardStack',
        'cardContainer',
        'stack',
        'childrenFlex',
        'radioCardFlexChild',
        'radioCardText',
        'customRadioInputContainer',
        'customRadioInputContainerBull',
        'closeButton',
        'checkboxDefault',
        'editPosition',
    ],
}
